import { formatMailDateTime } from './mailDates';

/** Normalisiert MySQL/SQLite-Booleans, Buffer und 0/1-Strings. */
export function normalizeUnsubscribeFlag(value) {
  if (value == null) return null;
  if (typeof value === 'boolean') return value ? 1 : 0;
  if (typeof value === 'object') {
    // mysql2 Buffer oder JSON-serialisierter Buffer
    if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(value)) {
      return value[0] ? 1 : 0;
    }
    if (value.type === 'Buffer' && Array.isArray(value.data)) {
      return value.data[0] ? 1 : 0;
    }
  }
  if (typeof value === 'string') {
    const s = value.trim().toLowerCase();
    if (s === '' || s === '0' || s === 'false' || s === 'no') return 0;
    if (s === '1' || s === 'true' || s === 'yes') return 1;
  }
  const n = Number(value);
  if (n === 0) return 0;
  if (n === 1) return 1;
  return null;
}

/** Kontakt hat sich von Kampagnen-/Newsletter-Mails abgemeldet. */
export function isContactUnsubscribed(contactOrCampaign) {
  if (!contactOrCampaign) return false;

  const flag = normalizeUnsubscribeFlag(
    contactOrCampaign.unsubscribed != null
      ? contactOrCampaign.unsubscribed
      : contactOrCampaign.contact_unsubscribed
  );

  // Explizites Kontakt-Flag hat immer Vorrang (auch nach Wiederherstellen)
  if (flag === 0) return false;
  if (flag === 1) return true;

  if (contactOrCampaign.unsubscribed_at || contactOrCampaign.contact_unsubscribed_at) {
    return true;
  }
  return String(contactOrCampaign.status || '').toLowerCase() === 'unsubscribed';
}

/** Adresse unzustellbar (Bounce) — kein Versand an diesen Kontakt. */
export function isContactBounced(contactOrCampaign) {
  if (!contactOrCampaign) return false;

  const flag = normalizeUnsubscribeFlag(
    contactOrCampaign.bounced != null
      ? contactOrCampaign.bounced
      : contactOrCampaign.contact_bounced
  );

  if (flag === 1) return true;
  if (flag === 0) {
    return String(contactOrCampaign.status || '').toLowerCase() === 'bounced';
  }
  if (contactOrCampaign.bounced_at || contactOrCampaign.contact_bounced_at) {
    return true;
  }
  return String(contactOrCampaign.status || '').toLowerCase() === 'bounced';
}

/** Kein Kampagnenversand: Abmeldung oder Bounce. */
export function isContactUnmailable(contactOrCampaign) {
  return isContactUnsubscribed(contactOrCampaign) || isContactBounced(contactOrCampaign);
}

/** Kontakt-Objekt für UI/API vereinheitlichen. */
export function withNormalizedSubscription(contact) {
  if (!contact || typeof contact !== 'object') return contact;
  const flag = normalizeUnsubscribeFlag(contact.unsubscribed);
  const unsubscribed = flag == null ? 0 : flag;
  return {
    ...contact,
    unsubscribed,
    unsubscribed_at: unsubscribed ? contact.unsubscribed_at || null : null,
    bounced: normalizeUnsubscribeFlag(contact.bounced) === 1 ? 1 : 0,
    bounced_at: contact.bounced_at || null,
  };
}

export function formatUnsubscribedAt(value) {
  if (!value) return '';
  return formatMailDateTime(value) || '';
}
